import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as moment from 'moment';
import { PointOfSaleClosing, PointOfSaleTimetable, TimeSlot } from 'src/app/services/api/fulle/fulle-pointOfSale/fulle-pointOfSale.service.interface';
import { CssService } from 'src/app/services/css-service';

type NextDay = { date: moment.Moment; timetable: PointOfSaleTimetable | null };

type SaleMethod = { id: number }; // ajustez si vous avez une vraie interface
type TimetablesBySaleMethod = { id_sale_method: number; timetables: PointOfSaleTimetable[] };

type PointOfSale = {
    timetables: PointOfSaleTimetable[];
    timetables_sm?: TimetablesBySaleMethod[] | null;
    closings?: PointOfSaleClosing[] | null;
};

type ShedulesDialogData = {
    point_of_sale: PointOfSale;
    sale_method: SaleMethod;
};

@Component({
    selector: 'app-fulle-shedules',
    templateUrl: './fulle-shedules.component.html',
    styleUrls: ['./fulle-shedules.component.css']
})
export class FulleShedulesComponent implements OnInit {

    @ViewChild('shedulesCont', { static: true }) shedulesCont!: ElementRef<HTMLElement>;

    point_of_sale: PointOfSale;
    sale_method: SaleMethod;
    closings: PointOfSaleClosing[] = [];
    contHeight: number | null = null;
    innerHeight = window.innerHeight;
    today = moment();
    nextDays: NextDay[] = [];

    constructor(private dialogRef: MatDialogRef<FulleShedulesComponent>,
        public cssService: CssService,
        @Inject(MAT_DIALOG_DATA) data: ShedulesDialogData,
    ) {
        this.point_of_sale = data.point_of_sale;
        this.sale_method = data.sale_method;
    }

    ngOnInit() {
        setTimeout(() => {
            this.contHeight = this.shedulesCont.nativeElement.clientHeight;
        });
        // set exeptionnels closed days
        if ((this.point_of_sale.closings?.length ?? 0) > 0) {
            this.setdayclosed(this.point_of_sale.closings ?? []);
        }
        this.buildNextDays();
    }

    private buildNextDays(): void {
        const tables = this.getTimeTables() ?? [];
        this.nextDays = Array.from({ length: 7 }).map((_, idx) => {
            const date = this.today.clone().startOf('day').add(idx, 'days');
            const iso = date.isoWeekday();
            const timetable = tables.find((d: PointOfSaleTimetable) => d.day === iso) ?? null;
            return { date, timetable };
        });
    }

    // Retourne le tableau des horaires associé au point de vente + mode de vente
    getTimeTables(): PointOfSaleTimetable[] {
        const sm = this.sale_method;
        // console.log("fulle-shedules.component - getTimeTables - sm : ", sm);
        const timetablesSm = this.point_of_sale.timetables_sm ?? [];
        // console.log("fulle-shedules.component - getTimeTables - this.point_of_sale : ", this.point_of_sale);
        // console.log("fulle-shedules.component - getTimeTables - timetablesSm : ", timetablesSm);
        // Parcours des modes de vente pour renvoi horaires par mode de vente
        const found = timetablesSm.find(x => x.id_sale_method === sm.id);
        return found?.timetables ?? this.point_of_sale.timetables ?? [];
    }


    // gere les jours fermés parce qu'il n'y a pas d'horaires sur la journée
    setdayclosed(closingHoraries: PointOfSaleClosing[]): void {
        const now = this.today.format("YYYY-MM-DD");
        this.closings = (closingHoraries ?? [])
            .filter(c => !!c?.date_from && c.date_from >= now);
    }

    // Ajoute les jours exceptionnels de fermeture dans les jours / horaire affichés
    isClosedForDate(date: moment.Moment): boolean {
        if (this.closings.length === 0) return false;
        return this.closings.some(c => {
            const from = moment(c.date_from, "YYYY-MM-DD");
            const to = moment(c.date_to, "YYYY-MM-DD");
            return date.isBetween(from, to, "day", "[]");
        });
    }

    getDayByIndex(dayindex: number): string {
        const format = "dddd";
        return moment().isoWeekday(dayindex).format(format);
    }

    checkCurrentDay(dayindex: number): boolean {
        return dayindex === this.today.isoWeekday();
    }

    checkCurrentHour(slot: TimeSlot): boolean {
        const start = moment(slot.start, "HH:mm:ss");
        let end = moment(slot.end, "HH:mm:ss");
        if (slot.end.startsWith("00")) {
            end = moment("23:59:59", "HH:mm:ss");
        }
        const now = this.today;
        return now.isBetween(start, end, undefined, "[]");
    }

    closeDial(): void {
        this.dialogRef.close();
    }
}
